import {Component, OnDestroy, OnInit} from '@angular/core';
import {AnmeldungStatus} from "../../models/enums";
import {AnmeldungService} from "../../service/anmeldung.service";
import {KindService} from "../../service/kind.service";
import {SessionService} from "../../service/session.service";
import {interval, Subscription} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {ElternService} from "../../service/eltern.service";

const DAY = 1000 * 60 * 60 * 24;

@Component({
  selector: 'app-voranmeldung-button',
  templateUrl: './voranmeldung-button.component.html',
  styleUrls: ['./voranmeldung-button.component.scss']
})
export class VoranmeldungButtonComponent implements OnInit, OnDestroy {

  private intervalSub!: Subscription;
  
  anmeldungenAktiv = false;
  anmeldungenDatum!: number;
  kinderZumAnmelden: boolean = false;
  anmeldungErledigt: boolean = false;
  showTimer = false;
  timeLeft = 0;
  timerTxt = "";
  loading = false;
  loggedIn = false;

  constructor(
      private readonly sessionService: SessionService,
      private readonly anmeldungService: AnmeldungService,
      private readonly toastrService: ToastrService,
      private readonly elternService: ElternService,
      private readonly kindService: KindService
  ) { }

  ngOnInit(): void {
    this.anmeldungenAktiv = this.anmeldungService.isAnmeldungActive();
    this.anmeldungenDatum = this.anmeldungService.getAnmeldungsbeginn();
    this.anmeldungErledigt = !!this.sessionService.session.nutzer.tstActivate;
    this.kinderZumAnmelden = this.kindService
        .getList()
        .filter(k => k.eltern.id === this.sessionService.session.nutzer.id)
        .some(k => k.anmeldungen.some(a => a.status === AnmeldungStatus.VORANGEMELDET));

    this.intervalSub = interval(500).subscribe(() => this.updateMsg());
    this.loggedIn = !!this.sessionService.session?.nutzer
  }


  updateMsg() {
    this.showTimer = Date.now() > this.anmeldungenDatum - DAY;
    if(!this.showTimer) {
      return;
    }

    this.anmeldungenAktiv = this.anmeldungenDatum <= Date.now();
    this.anmeldungErledigt = !!this.sessionService.session.nutzer.tstActivate;


    this.kinderZumAnmelden = this.kindService
        .getList()
        .filter(k => k.eltern.id === this.sessionService.session.nutzer.id)
        .some(k => k.anmeldungen.some(a => a.status === AnmeldungStatus.VORANGEMELDET));



    this.timeLeft = Math.floor((this.anmeldungenDatum - Date.now()) / 1000);
    const days = Math.floor(this.timeLeft / 86400);
    const hours = Math.floor((this.timeLeft % 86400) / 3600);
    const minutes = Math.floor((this.timeLeft % 3600) / 60);
    const seconds = this.timeLeft % 60;

    if (days > 0) {
      this.timerTxt = `${days} Tag${days > 1 ? 'e' : ''} ${hours}:${minutes.toString().padStart(2, '0')} Stunden`;
    } else if (hours > 0) {
      this.timerTxt = `${hours}:${minutes.toString().padStart(2, '0')} Stunden`;
    } else if (minutes > 0) {
      this.timerTxt = `${minutes}:${seconds.toString().padStart(2, '0')} Minuten`;
    } else {
      this.timerTxt = `${seconds} Sekunde${seconds > 1 ? 'n' : ''}`;
    }
    
  }
  
  ngOnDestroy(): void {
    this.intervalSub?.unsubscribe();
  }

  public async kinderAnmelden() {
    try{
      this.loading = true;
      const msg = await this.anmeldungService.kinderAnmelden();
      this.toastrService.success(msg);
      await this.elternService.updateData();
      this.updateMsg();
    } catch (e) {
      this.toastrService.error("Anmeldung fehlgeschlagen. Bitte prüfen Sie Ihre Uhrzeit an Ihrem Gerät oder versuchen Sie es in einigen Sekunden erneut.");
    } finally {
      this.loading = false;
    }
  }


}
